import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "max-w-[500px] mx-auto py-6" }
const _hoisted_2 = { class: "col-span-2" }
const _hoisted_3 = { class: "flex items-center justify-end w-full space-x-3" }

import { onMounted, ref } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import FormSection from "./FormSection.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import { useRouter } from "vue-router";
import Personnels from "@/classes/Personnels";
import { errorResponse } from "@/helpers/errorMessage";
import PageLoader from "@/components/loaders/PageLoader.vue";
import { RoleTypes } from "../enums/RoleTypes";
import ErrorModal from "@/components/modals/ErrorModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePage',
  setup(__props) {

const router = useRouter();
const loading = ref<boolean>(false);
const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const successMessage = ref<string>("Data has been successfully saved!");
const form = ref<{
	email: string;
	last_name: string;
	first_name: string;
	middle_name: string;
	mobile_number: string;
	home_address: string;
	is_temporary: boolean;
	department_id: any;
	office_id: any;
	role_id: any;
	position_id: any;
    is_active: boolean | null,
}>({
	email: "",
	last_name: "",
	first_name: "",
	middle_name: "",
	mobile_number: "",
	home_address: "",
	is_temporary: false,
	department_id: "",
	office_id: "",
	position_id: "",
	role_id: "",
    is_active: null,
});
const errors = ref<any>();
const officeOptions = ref<[]>([]);
const userGroupOptions = ref<[]>([]);
const positionOptions = ref<[]>([]);
const departmentOptions = ref<[]>([]);
const userRole = ref();
const showError = ref(false);

const save = (): void => {
	loading.value = true;
    showError.value = false;
	Personnels.store(form.value)
		.then((response: any) => {
			loading.value = false;
			showConfirmation.value = true;
			successMessage.value = response.data.message;
		})
		.catch((error: any) => {
			loading.value = false;
			(errors.value = errorResponse(error.response?.data?.errors || error.response?.data?.message))
            if (error.response.status == 403) {
                showError.value = true;
            }
		});
};

const redirectSuccess = (): void => {
	showSuccess.value = false;
	router.replace("/personnel/index");
};

const canCreate = () => {
    let hasAccess = false;
    if (userRole.value?.role_id == RoleTypes.SUPERADMIN 
    || userRole.value?.role_id == RoleTypes.SUPERADMIN_IT 
    || userRole.value?.role_id == RoleTypes.OFFICE_ADMIN) {
        hasAccess = true;
    }

    return hasAccess;
}

onMounted(() => {
    userRole.value =  JSON.parse(localStorage.getItem('user')); 
	Personnels.create()
		.then((response: any) => {
			officeOptions.value = response.data.offices;
			positionOptions.value = response.data.positions;
			userGroupOptions.value = response.data.userGroups;
			departmentOptions.value = response.data.departments;
		})
		.catch((error: any) => console.log(error));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backLink: "/personnel/index"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormSection, {
          form: form.value,
          errors: errors.value,
          departments: departmentOptions.value,
          positions: positionOptions.value,
          userGroups: userGroupOptions.value,
          offices: officeOptions.value
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).replace('/personnel/index/')))
                }, [
                  _createVNode(ButtonComponent, { btnWidth: "quinary" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cancel")
                    ]),
                    _: 1
                  })
                ]),
                (canCreate())
                  ? (_openBlock(), _createBlock(ButtonComponent, {
                      key: 0,
                      btnWidth: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (save()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Save Changes")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(ConfirmationModal, {
                typeTwo: true,
                show: showConfirmation.value,
                onCancel: _cache[2] || (_cache[2] = ($event: any) => (showConfirmation.value = false)),
                onConfirm: _cache[3] || (_cache[3] = ($event: any) => {
							showSuccess.value = true;
							showConfirmation.value = false;
						}),
                "cancel-text": "Cancel",
                "action-text": "Confirm",
                title: "Save Record",
                content: "Are you sure you wish to save this record?"
              }, null, 8, ["show"]),
              _createVNode(SuccessModal, {
                show: showSuccess.value,
                onConfirm: _cache[4] || (_cache[4] = ($event: any) => (redirectSuccess())),
                "action-text": "Close",
                title: "Record Saved!",
                content: successMessage.value
              }, null, 8, ["show", "content"]),
              _createVNode(ErrorModal, {
                show: showError.value,
                content: errors.value?.message
              }, null, 8, ["show", "content"])
            ])
          ]),
          _: 1
        }, 8, ["form", "errors", "departments", "positions", "userGroups", "offices"])
      ]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})